import { render, staticRenderFns } from "./UserChangeCompanyLogs.vue?vue&type=template&id=4603aece&scoped=true&"
import script from "./UserChangeCompanyLogs.vue?vue&type=script&lang=js&"
export * from "./UserChangeCompanyLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603aece",
  null
  
)

export default component.exports